import type Client from '../client'

import type {
  ErrorAble,
  SupplierResponse,
  RequestItemBag,
} from '@/api'

export default class Supplier {
  constructor(private client: Client) {}

  updateNotifications(data: {notify_on_new_booking: boolean, notify_on_booking_closed: boolean}) {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.put(`supplier/update-notifications`, { data }))
      } catch (error) {
        reject(error)
      }
    })
  }

  // eslint-disable-next-line
  invoices(supplier_id: number | null, query: RequestItemBag = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          await this.client.get('supplier/invoices', {
            query: { ...query, supplier_id },
          }),
        )
      } catch (error) {
        reject(error)
      }
    })
  }

  // eslint-disable-next-line
  toggleAutoAddToInvoice() {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.post('supplier/auto_add_to_invoice'))
      } catch (error) {
        reject(error)
      }
    })
  }

  // eslint-disable-next-line
  addToInvoice(data: []) {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.post('supplier/add_to_invoice', { data }))
      } catch (error) {
        reject(error)
      }
    })
  }

    updateInvoiceBankNumber(supplier: number, invoice_bank_number: string) {
        return new Promise(async (resolve, reject) => {
            try {
                resolve(
                    await this.client.put(`supplier/invoice-bank-number/${supplier}`, {
                        data: { invoice_bank_number }
                    })
                )
            } catch (error) {
                reject(error)
            }
        })
    }
}
